"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const opentracing_1 = require("opentracing");
// trace will wrap the given function in a span. This span will be a
// child of the parent span. If the function throws, then the span
// will be marked with an error, and the error messaage/stack will be
// logged on the span.
const trace = async (tracer, parent, name, fn) => {
    const opts = parent != null
        ? {
            childOf: parent
        }
        : undefined;
    const span = tracer.startSpan(name, opts);
    try {
        return await fn(span);
    }
    catch (err) {
        span.setTag(opentracing_1.Tags.ERROR, true);
        span.log({ error: err.toString(), stack: err.stack });
        throw err;
    }
    finally {
        span.finish();
    }
};
exports.trace = trace;
// traceContext will wrap the given function in a span. This span will
// be a child of any span in the passed context. The function will be
// called with a new context with the new span, to support nesting.
const traceContext = async (name, context, fn) => trace(context.tracing.tracer, context.tracing.span, name, async (span) => {
    const ctx = Object.assign({}, context, {
        tracing: {
            tracer: context.tracing.tracer,
            span
        }
    });
    return await fn(ctx);
});
exports.traceContext = traceContext;
//# sourceMappingURL=context.js.map